var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"linear"},[(_vm.show)?_c('v-progress-linear',{attrs:{"color":"primary darken-2","height":"4","indeterminate":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }